import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const SearchRepository = RepositoryFactory.get('SearchRepository');

export const STORE_MODULE_NAME = 'search';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        get_by_content_type_id ({ commit }, ctx) {
            console.log('fetchByContentTypeId')
            const { params } = ctx
            return new Promise((resolve, reject) => {
                SearchRepository.get_by_content_type_id(params)
                    .then((response) => resolve(response))
                    .catch((error) => reject(error))
            })
        },
        get_by_model_path ({ commit }, ctx) {
            const { params } = ctx
            return new Promise((resolve, reject) => {
                SearchRepository.get_by_model_path(params)
                    .then((response) => resolve(response))
                    .catch((error) => reject(error))
            })
        },
    },
}
